// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "specialist-260316-2/static/css/" + chunkId + "." + {"87":"dc5fbcd8","751":"4041d6a0","902":"d6fee0a3"}[chunkId] + ".chunk.css";
};